import {
    changeStorefrontPage,
    changeStoreFrontSearchTerms,
    getStorefrontViewData,
} from '../../../redux/modules/viewData';
import { parseQueryParams, validateQueryParams } from '../../../utils/queryParams';
import type { DataLoaderParams } from '../../../types/DataLoaderParams';
import { itemSortOrders } from '../../../enums';
import { loadStorefrontItems } from '../../../redux/modules/storefrontPage';
import { recordAnalyticsForStorefrontPageView } from '../../../redux/modules/analytics';

export default ({ location, match, store }: DataLoaderParams) => {
    const { params } = match;
    const queryParams = parseQueryParams(location.search);
    const { page, terms } = validateQueryParams(queryParams, itemSortOrders);

    const state = store.getState();
    const { dispatch } = store;
    const sellerId = Number(params.sellerId);

    const viewData = getStorefrontViewData(state, sellerId);

    const promises = [dispatch(loadStorefrontItems(sellerId))];

    if (viewData.page !== page) {
        promises.push(dispatch(changeStorefrontPage(sellerId, page)));
    }

    if (viewData.searchTerms !== terms) {
        promises.push(dispatch(changeStoreFrontSearchTerms(sellerId, terms)));
    }

    return Promise.all(promises).then(() => {
        return dispatch(recordAnalyticsForStorefrontPageView(sellerId));
    });
};
